import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <main className="nf-page">
      <div className="nf-container">
        <p className="nf-code">404</p>
        <h1>This page doesn't exist.</h1>
        <p className="nf-lede">
          The link may be broken, or the page may have moved.
          Either way, here's where to go from here.
        </p>
        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn-primary nf-btn-arrow">
            Back to home
          </Link>
          <Link to="/services" className="nf-btn nf-btn-secondary">
            View services
          </Link>
          <Link to="/contact" className="nf-btn nf-btn-secondary">
            Get in touch
          </Link>
        </div>
      </div>
    </main>
  );
}

export default NotFound;